module.exports = __webpack_public_path__ + "/images/logo-fr-vertbaudet.7b50228.png";